export default {
  modelLabel: {
    id: 'buyback_refurbisher_listing_filters_model',
    defaultMessage: 'Model',
  },
  brandLabel: {
    id: 'buyback_refurbisher_listing_filters_brand',
    defaultMessage: 'Brand',
  },
  gradeLabel: {
    id: 'buyback_refurbisher_listing_filters_grade',
    defaultMessage: 'Grade',
  },
  gradeAll: {
    id: 'buyback_refurbisher_listing_filters_grade_all',
    defaultMessage: 'All',
  },
  gradeDiamond: {
    id: 'buyback_refurbisher_listing_filters_grade_diamond',
    defaultMessage: 'Functional - Flawless',
  },
  gradePlatinum: {
    id: 'buyback_refurbisher_listing_filters_grade_platimum',
    defaultMessage: 'Functional - Good',
  },
  gradeGold: {
    id: 'buyback_refurbisher_listing_filters_grade_gold',
    defaultMessage: 'Functional - Used',
  },
  gradeSilver: {
    id: 'buyback_refurbisher_listing_filters_grade_silver',
    defaultMessage: 'Functional - Cracked',
  },
  gradeBronze: {
    id: 'buyback_refurbisher_listing_filters_grade_bronze',
    defaultMessage: 'Not functional - Broken parts with scratches',
  },
  gradeStallone: {
    id: 'buyback_refurbisher_listing_filters_grade_stallone',
    defaultMessage: 'Not functional - Broken parts with cracks',
  },
  applyFilters: {
    id: 'buyback_refurbisher_listing_apply_filters',
    defaultMessage: 'Apply filters',
  },
  reset: {
    id: 'buyback_refurbisher_listing_reset_filters',
    defaultMessage: 'Reset',
  },
  showMoreFilters: {
    id: 'buyback_refurbisher_listing_show_more_filters',
    defaultMessage: 'Show more filters',
  },
  showLessFilters: {
    id: 'buyback_refurbisher_listing_show_less_filters',
    defaultMessage: 'Show less filters',
  },
  backboxLabel: {
    id: 'buyback_refurbisher_listing_filters_backbox',
    defaultMessage: 'BackBox',
  },
  withAndWithoutBackbox: {
    id: 'buyback_refurbisher_listing_filters_with_and_without_backbox',
    defaultMessage: 'With and without BackBox',
  },
  withBackbox: {
    id: 'buyback_refurbisher_listing_filters_with_backbox',
    defaultMessage: 'With BackBox',
  },
  withoutBackbox: {
    id: 'buyback_refurbisher_listing_filters_without_backbox',
    defaultMessage: 'Without BackBox',
  },
  publicationStateLabel: {
    id: 'buyback_refurbisher_listing_filters_online_state_label',
    defaultMessage: 'Online State',
  },
  onlineAndOffline: {
    id: 'buyback_refurbisher_listing_filters_online_and_offline_state',
    defaultMessage: 'Online and offline',
  },
  online: {
    id: 'buyback_refurbisher_listing_filters_online_state',
    defaultMessage: 'Online',
  },
  offline: {
    id: 'buyback_refurbisher_listing_filters_offline_state',
    defaultMessage: 'Offline',
  },
  prodcutIdLabel: {
    id: 'buyback_refurbisher_listing_filters_product_id',
    defaultMessage: 'Product ID',
  },
  skuLabel: {
    id: 'buyback_refurbisher_listing_filters_sku',
    defaultMessage: 'SKU',
  },
  releaseYearLabel: {
    id: 'buyback_refurbisher_listing_filters_year',
    defaultMessage: 'Release year',
  },
  filter: {
    id: 'buyback_refurbisher_listing_filters_modal_title',
    defaultMessage: 'Filter',
  },
}
